<template>
  <div class="dashboard-loading-overlay" v-if="visible">
    <div class="loading-container">
      <!-- 主要的旋转环 -->
      <div class="loading-ring">
        <div class="ring-outer"></div>
        <div class="ring-middle"></div>
        <div class="ring-inner"></div>
      </div>

      <!-- 中心脉冲点 -->
      <div class="loading-pulse"></div>

      <!-- 扫描线效果 -->
      <div class="scan-line"></div>

      <!-- 加载文字 -->
      <div class="loading-text" v-if="text">
        {{ text }}
        <span class="loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardLoading',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: '数据加载中'
    },
    size: {
      type: String,
      default: 'normal', // small, normal, large
      validator: value => ['small', 'normal', 'large'].includes(value)
    }
  }
}
</script>

<style scoped>
.dashboard-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 15, 40, 0.8);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  border-radius: 8px;
}

.loading-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 旋转环效果 */
.loading-ring {
  position: relative;
  width: 80px;
  height: 80px;
}

.ring-outer,
.ring-middle,
.ring-inner {
  position: absolute;
  border-radius: 50%;
  border: 2px solid transparent;
  animation: rotate 2s linear infinite;
}

.ring-outer {
  width: 80px;
  height: 80px;
  border-top: 2px solid #0096ff;
  border-right: 2px solid rgba(0, 150, 255, 0.3);
  animation-duration: 2s;
  box-shadow: 0 0 20px rgba(0, 150, 255, 0.3);
}

.ring-middle {
  width: 60px;
  height: 60px;
  top: 10px;
  left: 10px;
  border-top: 2px solid #00ff88;
  border-left: 2px solid rgba(0, 255, 136, 0.3);
  animation-duration: 1.5s;
  animation-direction: reverse;
  box-shadow: 0 0 15px rgba(0, 255, 136, 0.3);
}

.ring-inner {
  width: 40px;
  height: 40px;
  top: 20px;
  left: 20px;
  border-top: 2px solid #ff6b6b;
  border-bottom: 2px solid rgba(255, 107, 107, 0.3);
  animation-duration: 1s;
  box-shadow: 0 0 10px rgba(255, 107, 107, 0.3);
}

/* 中心脉冲点 */
.loading-pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
}

/* 扫描线效果 */
.scan-line {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 2px;
  background: linear-gradient(90deg,
    transparent 0%,
    #0096ff 20%,
    #ffffff 50%,
    #00ff88 80%,
    transparent 100%);
  animation: scan 2s linear infinite;
  opacity: 0.8;
}

/* 加载文字 */
.loading-text {
  margin-top: 30px;
  color: #b8d4f0;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 5px;
  text-shadow: 0 0 10px rgba(184, 212, 240, 0.5);
}

.loading-dots {
  display: inline-flex;
  gap: 2px;
}

.dot {
  width: 4px;
  height: 4px;
  background: #0096ff;
  border-radius: 50%;
  animation: dotPulse 1.4s ease-in-out infinite both;
}

.dot:nth-child(1) { animation-delay: -0.32s; }
.dot:nth-child(2) { animation-delay: -0.16s; }
.dot:nth-child(3) { animation-delay: 0s; }

/* 动画定义 */
@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0.7;
  }
}

@keyframes scan {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
    opacity: 0;
  }
}

@keyframes dotPulse {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

/* 尺寸变体 */
.dashboard-loading-overlay.size-small .loading-ring {
  width: 60px;
  height: 60px;
}

.dashboard-loading-overlay.size-small .ring-outer {
  width: 60px;
  height: 60px;
}

.dashboard-loading-overlay.size-small .ring-middle {
  width: 45px;
  height: 45px;
  top: 7.5px;
  left: 7.5px;
}

.dashboard-loading-overlay.size-small .ring-inner {
  width: 30px;
  height: 30px;
  top: 15px;
  left: 15px;
}

.dashboard-loading-overlay.size-small .scan-line {
  width: 75px;
}

.dashboard-loading-overlay.size-small .loading-text {
  font-size: 12px;
  margin-top: 20px;
}

.dashboard-loading-overlay.size-large .loading-ring {
  width: 100px;
  height: 100px;
}

.dashboard-loading-overlay.size-large .ring-outer {
  width: 100px;
  height: 100px;
}

.dashboard-loading-overlay.size-large .ring-middle {
  width: 75px;
  height: 75px;
  top: 12.5px;
  left: 12.5px;
}

.dashboard-loading-overlay.size-large .ring-inner {
  width: 50px;
  height: 50px;
  top: 25px;
  left: 25px;
}

.dashboard-loading-overlay.size-large .scan-line {
  width: 125px;
}

.dashboard-loading-overlay.size-large .loading-text {
  font-size: 16px;
  margin-top: 40px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .loading-ring {
    width: 60px;
    height: 60px;
  }

  .ring-outer {
    width: 60px;
    height: 60px;
  }

  .ring-middle {
    width: 45px;
    height: 45px;
    top: 7.5px;
    left: 7.5px;
  }

  .ring-inner {
    width: 30px;
    height: 30px;
    top: 15px;
    left: 15px;
  }

  .scan-line {
    width: 75px;
  }

  .loading-text {
    font-size: 12px;
    margin-top: 20px;
  }
}
</style>
